(ns frontend.view.entity-merge.attachments
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [frontend.view.entity-merge.components :as components]
            [frontend.view.entity-merge.events :as events]
            [frontend.view.task.webentry-resolution.components :as we]))

(defmethod components/step-info :attachments [{:keys [entity-type] :as signals} [step-kw _step-params]]
  (loc/tr :entity-merge-step/attachments-info [(->> (loc/tr entity-type)
                                                (string/lower-case))]))

(defn review [{:keys [state r-target r-source] :as signals}]
  (let [rejection-path [:rejection :attachments]
        rejection (get-in @state rejection-path)
        target-attachments (->> @r-target
                                :common/attachments
                                (keep events/get-entity))
        source-attachments (->> @r-source
                                :common/attachments
                                (keep events/get-entity))
        selected-attachments (->> target-attachments
                                  (concat source-attachments)
                                  (remove (fn [{:keys [db/id]}]
                                            (contains? rejection id)))
                                  distinct)]
    [components/review-card signals
     {:title (loc/tr :attachments)
      :collapsed-path [:review-attachments]
      :content
      [:div
       (doall
        (for [{:keys [db/id] :as attachment} selected-attachments]
          ^{:key (str "attachment-" id)}
          [:div
           [we/attachment-view nil attachment]]))]}]))

(defn view [{:keys [state r-source r-target] :as signals}]
  (let [rejection-path [:rejection :attachments]
        toggle-attachment! (partial events/toggle! state rejection-path)]
    (fn [{:keys [r-source r-target] :as signals}]
      (let [source-attachments (->> @r-source
                                    :common/attachments
                                    (keep events/get-entity))
            target-attachments (->> @r-target
                                    :common/attachments
                                    (keep events/get-entity))
            rejection (get-in @state rejection-path)]
        [:div.asset-updater-table__fields
         [:div.asset-updater-table__field
          [:div.asset-updater-table__compare
           [:div
            {:class-name "mt-4 grid grid-cols-10 gap-4 px-4"}
            [:div
             (doall
              (for [{:keys [db/id] :as attachment} source-attachments]
                ^{:key (str "attachment-" id)}
                [:div
                 [we/select-attachment-view attachment (not (contains? rejection id)) toggle-attachment!]]))]

            [:div
             (doall
              (for [{:keys [db/id] :as attachment} target-attachments]
                ^{:key (str "attachment-" id)}
                [:div
                 [we/select-attachment-view attachment (not (contains? rejection id)) toggle-attachment!]]))]]]]]))))
